import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';

import RegistrationSuccess from '@/components/organism/Registration/RegistrationSuccess';

const AUTO_REDIRECT_MS = 5000;

export default function RecoverySuccessPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      void navigate({ to: '/login' });
    }, AUTO_REDIRECT_MS);
    return () => {
      clearTimeout(timer);
    };
  }, [navigate]);

  const handleContinue = () => {
    void navigate({ to: '/login' });
  };

  return (
    <RegistrationSuccess
      title="Password updated"
      body="You can now sign in with your new password. We'll redirect you in a few seconds."
      buttonLabel="Go to login"
      onContinue={handleContinue}
    />
  );
}
